export const eventoBanners = {
  em_andamento: [
    {
      id: "1",
      desktop:
        "https://gerenciador.faculdadecerrado.edu.br/uploads/Eventos/Eventocancelado.webp",
      alt: "Evento em andamento",
      link: null,
    },
  ],

  em_breve: [
    {
      id: "2",
      desktop:
        "https://gerenciador.faculdadecerrado.edu.br/uploads/Eventos/Eventoemandamento.webp",
      alt: "Evento em breve",
    },
  ],

  encerrado: [
    {
      id: "3",
      desktop:
        "https://gerenciador.faculdadecerrado.edu.br/uploads/Eventos/Eventoencerrado.webp",
      alt: "Evento encerrado",
    },
  ],

  cancelado: [
    {
      id: "4",
      desktop:
        "https://gerenciador.faculdadecerrado.edu.br/uploads/Eventos/Eventocancelado.webp",
      alt: "Evento cancelado",
    },
  ],
};
